import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
} from "../../../util/varios";
import { Dimmer } from "../../spinner";
import "react-tabs/style/react-tabs.css";
import TablaDeudasEjidos from "./tablaDeudaEjidos";
import TablaHistoricosEjidos from "./tabaHistoricoEjidos";
import moment from "moment";
import axios from "axios";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";
import { Input, Radio, Select, Textarea } from "../../../ui/inputs/Input";

export const RegistroContribuyenteEconomiaInformal = (props) => {
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [operacion, setOperacion] = useState(0);
  const [anio, setAnio] = useState([]);
  const [tipopersona, setTipoPersona] = useState(4);
  const [status, setStatus] = useState(1);
  const [tecla] = useState();
  const [factorCambio, setFactorCambio] = useState(0);
  const [deuda, setDeuda] = useState();
  const [desde1, setDesde1] = useState(0);
  const [desde2, setDesde2] = useState(0);

  const btnCancela = useRef();
  const btnCargar = useRef();
  const txtRitm = useRef();
  const txtDirecI = useRef();
  const txtCodCats = useRef();
  const txtTipoRenta = useRef();
  const txtFechaC = useRef();
  const txtContrato = useRef();
  const txtCodCon = useRef();
  const txtCheckNatural = useRef();
  const txtCheckJuridico = useRef();
  const txtRazonS = useRef();
  const cmbCedRif = useRef();
  const txtCedRif = useRef();
  const txtTlf = useRef();
  const txtDirecI2 = useRef();
  const txtTipoActividad = useRef();
  const txtid = useRef();
  const txtActivo = useRef();
  const txtInactivo = useRef();
  const txtMontoAval = useRef();
  const txtAreaConstruccion = useRef();
  const txtAreaTerreno = useRef();
  const txtHasta = useRef();
  const txtDesde = useRef();
  const txtUsoInmueble = useRef();
  const txtUltimoAval = useRef();
  const txtTipo = useRef();
  const txtNumLoc = useRef();
  const txtDuracion = useRef();
  const txtCompra = useRef();
  const txtSimple = useRef();
  const txtMensual = useRef();
  const txtTrimestral = useRef();
  const txtAnual = useRef();
  const txtMontoPagar = useRef();
  const txtAñoDeuda = useRef();
  const txtDesdeDeuda = useRef();
  const txtHastaDeuda = useRef();

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (
      mensaje.texto == "registro creado correctamente." ||
      mensaje.texto == "registro modificado correctamente." ||
      mensaje.texto == "registro eliminado correctamente."
    ) {
      blanquear();
      props.onHideCancela();
    }
    if (mensaje.texto === "Deuda Cargada") {
      props.onHideRenderizar();
    }
  };
  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.target.id === "montopagar") {
        if (event.which === 13) {
          btnCargar.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  const blanquear = () => {
    setActivate(false);
    setDeuda();
    setDesde1(0);
    setDesde2(0);
    setTipoPersona(4);
    txtDirecI2.current.value = "";
    txtRazonS.current.value = "";
    txtCedRif.current.value = "";
    txtTlf.current.value = "";
    txtTipoRenta.current.value = "";
    txtTipoActividad.current.value = "";
    txtCheckNatural.current.checked = false;
    txtCheckJuridico.current.checked = false;
    txtMensual.current.checked = false;
    txtTrimestral.current.checked = false;
    txtAnual.current.checked = false;
  };

  const validarCampos = (e) => {
    e.preventDefault();
    var sigue = true;
    if (operacion !== 4) {
      if (txtTipoRenta.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar un tipo de Renta",
          icono: "informacion",
        });
        txtTipoRenta.current.focus();
        sigue = false;
      } else if (txtContrato.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar el Número de Registro",
          icono: "informacion",
        });
        txtContrato.current.focus();
        sigue = false;
      } else if (txtFechaC.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar la Fecha del Registro",
          icono: "informacion",
        });
        txtFechaC.current.focus();
        sigue = false;
      } else if (
        !txtCheckJuridico.current.checked &&
        !txtCheckNatural.current.checked
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar si es Prs.Natural o Prs.Juridica",
          icono: "informacion",
        });
        txtCheckJuridico.current.focus();
        sigue = false;
      } else if (cmbCedRif.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar la Letra de la Cedula o Rif",
          icono: "informacion",
        });
        cmbCedRif.current.focus();
        sigue = false;
      } else if (txtCedRif.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar el Número de Cedula o Rif",
          icono: "informacion",
        });
        txtCedRif.current.focus();
        sigue = false;
      } else if (txtTlf.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar un Número de Telefono Valido",
          icono: "informacion",
        });
        txtTlf.current.value = "";
        txtTlf.current.focus();
        sigue = false;
      } else if (txtRazonS.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar el Nombre o Razon Social",
          icono: "informacion",
        });
        txtRazonS.current.focus();
        sigue = false;
      } else if (txtDirecI2.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar la Dirección",
          icono: "informacion",
        });
        txtDirecI2.current.focus();
        sigue = false;
      } else if (txtTipoActividad.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar la Actividad Principal",
          icono: "informacion",
        });
        txtTipoActividad.current.focus();
        sigue = false;
      } else if (
        !txtMensual.current.checked &&
        !txtTrimestral.current.checked &&
        !txtAnual.current.checked
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar un Periodo de Cancelacion",
          icono: "informacion",
        });
        txtMensual.current.focus();
        sigue = false;
      } else if (sigue === true) {
        selectRenta(props.operacion);
      }
    }
  };
  const selectRenta = (operacion) => {
    let endpoint = `${op.conexion}/api/aseo/createaseo/${operacion}`;
    let body;
    setActivate(true);

    var periodo;
    var tipoAren;

    if (txtMensual.current.checked) {
      periodo = 1;
      console.log("subio 1");
    } else if (txtTrimestral.current.checked) {
      periodo = 2;
      console.log("subio 2");
    } else if (txtAnual.current.checked) {
      periodo = 3;
      console.log("subio 3");
    }
    tipoAren = "null";

    body = {
      nid: parseInt(txtid.current.value),
      idinmue: 0,
      numcontra: txtContrato.current ? txtContrato.current.value : "",
      feccontra: txtFechaC.current ? txtFechaC.current.value : "",
      idTipren:
        txtTipoRenta.current.value === "" ? null : txtTipoRenta.current.value,
      tipper: txtCheckNatural.current.checked
        ? 0
        : txtCheckJuridico.current.checked
        ? 1
        : null,
      nomarren: txtRazonS.current.value === "" ? null : txtRazonS.current.value,
      dire: txtDirecI2.current.value === "" ? null : txtDirecI2.current.value,
      ced:
        txtCedRif.current.value === ""
          ? null
          : cmbCedRif.current.value + txtCedRif.current.value,
      tlf: txtTlf.current.value === "" ? null : txtTlf.current.value,
      fecini: null,
      fecfin: null,
      monarren:
        operacion === 1
          ? 0
          : txtMontoPagar.current.value.replace(/\./g, "").replace(",", "."),
      tiparren: null,
      pericance: periodo,
      duracont: null,
      tiploc: null,
      numloc: null,
      tipacti:
        txtTipoActividad.current.value == ""
          ? null
          : txtTipoActividad.current.value,
      codimpu: parseInt(
        JSON.stringify(
          props.rentas[txtTipoRenta.current.selectedIndex].codigoimpuesto
        )
      ),
      nritm: null,
      tiptab: null,
      clasif: null,
      sta: status,
      moti: null,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          props.onHideRenderizar();
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente.",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente.",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const onChange = (event) => {
    if (
      event.target.name === "razonS" ||
      event.target.name === "directInm" ||
      event.target.name === "actP" ||
      event.target.name === "ritm" ||
      event.target.name === "codCon" ||
      event.target.name === "codCats" ||
      event.target.name === "directInm" ||
      event.target.name === "directInm2" ||
      event.target.name === "actividadP" ||
      event.target.name === "inputCedula"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }

    if (event.target.name === "inputTipo") {
    }

    if (event.target.name === "anioDeuda") {
      let nan = event.target.value;
    }

    if (event.target.name === "selectDesde") {
      let nan = event.target.value;
    }

    if (event.target.name === "selectHasta") {
      let nan = event.target.value;
    }

    if (event.target.name === "inputDesde") {
    }

    if (event.target.name === "inputHasta") {
    }
  };

  const validarParaCargarDeuda = (event) => {
    event.preventDefault();
    var sigue = true;
    if (operacion === 2) {
      if (txtAñoDeuda.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar el Año para cargar la Deuda",
          icono: "informacion",
        });
        txtAñoDeuda.current.focus();
        sigue = false;
      } else if (
        txtDesdeDeuda.current.value === "" ||
        txtHastaDeuda.current.value === ""
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar el periodo de inicio y final",
          icono: "informacion",
        });
        txtDesdeDeuda.current.focus();
        sigue = false;
      } else if (
        parseInt(txtDesdeDeuda.current.value) >
        parseInt(txtHastaDeuda.current.value)
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "La Fecha de inicio no puede ser mayor a la fecha final",
          icono: "informacion",
        });
        txtDesdeDeuda.current.value = "1";
        txtHastaDeuda.current.value = "1";
        txtDesdeDeuda.current.focus();
        sigue = false;
      } else if (txtMontoPagar.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar un monto para la deuda",
          icono: "informacion",
        });
        txtMontoPagar.current.focus();
        sigue = false;
      } else if (sigue) {
        selectCargarDeuda();
      }
    }
  };

  const selectCargarDeuda = () => {
    let endpoint = "";
    let body;
    if (espiritu === 0) {
      endpoint = `${op.conexion}/api/aseo/creardeudarenta`;
      body = {
        operacion: 1,
        id: parseInt(
          props.inmobiliaria
            ? props.inmobiliaria.idrentas !== null
              ? props.inmobiliaria.idrentas.trim()
              : ""
            : ""
        ),
        nomtab: "deudarentas",
        nomid: "idrentas",
        peri: props.periodoPagoR,
        monto: parseFloat(
          txtMontoPagar.current.value.replace(/\./g, "").replace(",", "."),
          4
        ),
        nanio: parseInt(txtAñoDeuda.current.value),
        mesdesde: parseInt(txtDesdeDeuda.current.value),
        meshasta: parseInt(txtHastaDeuda.current.value),
        nomiddeu: "iddeudarentas",
        tipo: 0,
      };
    } else {
      endpoint = `${op.conexion}/api/aseo/creardeudarenta1`;
      body = {
        operacion: 1,
        id: parseInt(
          props.inmobiliaria
            ? props.inmobiliaria.idrentas !== null
              ? props.inmobiliaria.idrentas.trim()
              : ""
            : ""
        ),
        nomtab: "deudarentas",
        monto: parseFloat(
          txtMontoPagar.current.value.replace(/\./g, "").replace(",", "."),
          4
        ),
        nanio: parseInt(txtAñoDeuda.current.value),
        mesdesde: parseInt(txtDesdeDeuda.current.value),
        meshasta: parseInt(txtHastaDeuda.current.value),
        peri: props.periodoPagoR,
      };
    }

    //let endpoint = `${op.conexion}/api/aseo/creardeudarenta1`;

    console.log(body);

    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setActivate(false);

          setDesde1(1);
          SelectDeudaC(txtid.current.value);
          setMensaje({
            mostrar: true,
            titulo: "Notificacion",
            texto: "Deuda Cargada",
            icono: "error",
          });
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.id === "inputTlf") {
        txtTlf.current.value.toString().trim().padStart(2, 0);

        if (event.which === 13) {
          txtTlf.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleChangeTipoPersona = (event) => {
    if (event.target.value === "0") {
      setTipoPersona(0);
      txtCheckNatural.current.checked = true;
      txtCheckJuridico.current.checked = false;
    } else {
      setTipoPersona(1);
      txtCheckNatural.current.checked = false;
      txtCheckJuridico.current.checked = true;
    }
  };

  const salir = () => {
    props.onHideCancela();
    blanquear();
  };

  useEffect(() => {
    let anioact = JSON.parse(localStorage.getItem("efiscalanio"));
    var nanio = [];
    var aini = parseInt(anioact) - 7;
    var afin = parseInt(anioact);
    for (let i = 0; i + aini <= afin; i++) {
      nanio.push({ anio: afin - i });
    }
    setAnio(nanio);
  }, [props]);

  useEffect(() => {
    if (
      props.operacion !== 1 &&
      props.inmobiliaria &&
      props.inmobiliaria.tipopersona <= 1
    ) {
      let letra = "";
      let pos = 0;
      let tipo = 4;
      if (desde2 === 0) {
        tipo = props.inmobiliaria.tipopersona;
        if (tipo === 0) {
          txtCheckNatural.current.checked = true;
          txtCheckJuridico.current.checked = false;
        } else {
          txtCheckNatural.current.checked = false;
          txtCheckJuridico.current.checked = true;
        }
        if (
          props.inmobiliaria.cedrif.toUpperCase().charCodeAt(0) > 64 &&
          props.inmobiliaria.cedrif.toUpperCase().charCodeAt(0) < 91
        ) {
          letra = props.inmobiliaria.cedrif.substring(0, 1);
          pos = 1;
        } else {
          if (tipo === 0) {
            letra = "V";
          } else {
            letra = "J";
          }
          pos = 0;
        }
        cmbCedRif.current.value = letra;
        txtCedRif.current.value = props.inmobiliaria.cedrif.substring(
          pos,
          props.inmobiliaria.cedrif.trim().length
        );
      } else {
        tipo = tipopersona;
        cmbCedRif.current.value = "";
      }
      setDesde2(1);
    }
  }, [tipopersona]);

  const mostrare = () => {
    const selectedIndex = txtTipoRenta.current.selectedIndex - 1;
    if (
      parseInt(JSON.stringify(props.rentas[selectedIndex].codigoimpuesto)) === 1
    ) {
    } else {
    }
  };

  const SelectDeudaC = (idrentas) => {
    let tabla = "aseo";
    let endpoint = "";
    if (espiritu === 0) {
      endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
    } else {
      //endpoint = `${op.conexion}/api/aseo/deudarenta1?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
      endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
    }
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu * factorCambio,
                intereses: response.data[i].intmoradeu * factorCambio,
                multa: response.data[i].multa * factorCambio,
                recargo: response.data[i].recargodeu * factorCambio,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
              });
            }
          }
          setDeuda(deu);
          setActivate(false);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setFactorCambio(props.factorCambio);
        setOperacion(props.operacion);
        setDesde1(0);
        if (props.operacion === 1) {
          txtFechaC.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
          txtMensual.current.checked = true;
          txtTrimestral.current.checked = false;
          txtAnual.current.checked = false;
          setTipoPersona(0);
          txtCheckNatural.current.checked = true;
          txtCheckJuridico.current.checked = false;
        } else {
          console.log(props.inmobiliaria);
          setDesde2(0);
          setTipoPersona(props.inmobiliaria.tipopersona);
          if (props.inmobiliaria && props.inmobiliaria.numcontra !== "") {
          } else {
          }
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between text-light rounded-top azulGradiant">
        <h3 className="m-0 fw-bold">
          {operacion === 1
            ? "Registrar Contribuyente Economía Informal."
            : operacion === 2
            ? "Editar Contribuyente Economía Informal."
            : operacion === 3
            ? "Eliminar Contribuyente Economía Informal."
            : "Consultar Contribuyente Economía Informal."}
        </h3>
        <a
          type="button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div>
          <ul className="nav mb-2" id="ex-with-icons" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link active bg-blue-100 text-light"
                id="datosTributarios"
                data-bs-toggle="tab"
                data-bs-target="#tributarios"
                type="button"
                role="tab"
                aria-controls="tributarios"
                aria-selected="true"
              >
                Datos Generales
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                rounded
                className="nav-link bg-blue-200 text-light"
                disabled={operacion === 1 || operacion === 3 ? true : false}
                id="deuda-tab"
                data-bs-toggle="tab"
                data-bs-target="#deuda"
                type="button"
                role="tab"
                aria-controls="deuda"
                aria-selected="false"
              >
                Deudas del Contribuyente
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-300 text-light"
                disabled={operacion === 1 || operacion === 3 ? true : false}
                id="hist-tab"
                data-bs-toggle="tab"
                data-bs-target="#historico"
                type="button"
                role="tab"
                aria-controls="historico"
                aria-selected="false"
              >
                Historicos de Pagos
              </a>
            </li>
            <div className="input-group mr-0 input-group-sm mb-1 col-md-2">
              <span className="input-group-text bg-transparent fw-bold border-0">
                Valor Euro €:
              </span>
              <span className="input-group-text bg-transparent fw-bold border-0">
                {formatMoneda(
                  factorCambio.toString().replace(",", "").replace(".", ","),
                  ",",
                  ".",
                  2
                )}
              </span>
            </div>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="tributarios"
              role="tabpanel"
              aria-labelledby="datosTributarios"
            >
              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                <div className="col-2 m-0 p-0">
                  <Input label = "Código:"
                    ref={txtid}
                    disabled
                    defaultValue={
                      props.inmobiliaria
                        ? props.inmobiliaria.idrentas !== null
                          ? props.inmobiliaria.idrentas.trim()
                          : ""
                        : ""
                    }
                    id="inputCodigo"
                  />
                </div>
                <div className="col-4 m-0 p-0 pl-2">
                  <Select label = "Tipo de Renta:"
                    name="idclasevehiculo"
                    ref={txtTipoRenta}
                    disabled={operacion === 1 ? false : true}
                    value={props.inmobiliaria && props.inmobiliaria.idtiporenta}
                    onChange={mostrare}
                    id="inputTP"
                  >
                    {props.rentas &&
                      props.rentas.map((item, index) => (
                        <option
                          key={item.codigoimpuesto}
                          value={item.idtiporentas}
                        >
                          {item.descripcion}
                        </option>
                      ))}
                  </Select>
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input label = 'N° Registro:'
                    ref={txtContrato}
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    id="codCats"
                    name="codCats"
                    defaultValue={
                      props.inmobiliaria &&
                      props.inmobiliaria.numcontrato !== ""
                        ? props.inmobiliaria.numcontrato
                        : " "
                    }
                  />
                </div>
                <div className="col-3 m-0 p-0 pl-2">
                  <Input label = 'Fecha Registro:'
                    type="date"
                    disabled={operacion === 1 || operacion === 2 ? false : true}
                    ref={txtFechaC}
                    id="codCats"
                    name="codCats"
                    defaultValue={
                      props.inmobiliaria &&
                      props.inmobiliaria.fechacontrato !== ""
                        ? moment.utc(props.inmobiliaria.fechacontrato).format(
                            "YYYY-MM-DD"
                          )
                        : " "
                    }
                  />
                </div>
                {operacion !== 1 &&
                  <div className="col-12 m-0 mt-2 p-0 d-flex gap-2">
                    <span className="fw-bold">
                        Status
                    </span>

                    <div className="col-auto m-0 p-0">
                      <Radio label  = 'Activo'
                        ref={txtActivo}
                        disabled={operacion === 2 ? false : true}
                        name="checkStatus"
                        value={0}
                        defaultChecked={
                          props.inmobiliaria && props.inmobiliaria.status === 0
                        }
                        id="checkStatus"
                        onChange={(event) => setStatus(event.target.value)}
                      />
                    </div>

                    <div className="col-auto m-0 p-0">
                      <Radio label = 'Inactivo'
                        ref={txtInactivo}
                        disabled={operacion === 2 ? false : true}
                        name="checkStatus"
                        value={1}
                        defaultChecked={
                          props.inmobiliaria && props.inmobiliaria.status === 1
                        }
                        id="checkStatus"
                        onChange={(event) => setStatus(event.target.value)}
                      />
                    </div>
                  </div>
                }
                <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                  <legend className="float-none w-auto m-0">
                    Datos del Arrendatario
                  </legend>
                  <div className="col-6 m-0 mb-2 p-0 d-flex gap-2">
                    <span className="fw-bold">
                      Tipos de Contribuyentes:
                    </span>
                    <div className="col-auto m-0 p-0">
                      <Radio label = 'Prs. Natural'
                        ref={txtCheckNatural}
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        name="radioPers"
                        value={"0"}
                        id="radioPers"
                        onChange={handleChangeTipoPersona}
                      />
                    </div>

                    <div className="col-auto m-0 p-0">
                      <Radio label = 'Prs. Jurídica'
                        ref={txtCheckJuridico}
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        name="radioPers"
                        value={"1"}
                        id="radioPers"
                        onChange={handleChangeTipoPersona}
                      />
                    </div>
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 d-flex">
                    {tipopersona === 0 ? (
                      <Select label = 'Cedula/Rif:'
                        ref={cmbCedRif}
                        id="inputCedRif"
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                      >
                        <option value="V">V</option>
                        <option value="E">E</option>
                      </Select>
                    ) : (
                      <Select label = 'Cedula/Rif:'
                        ref={cmbCedRif}
                        id="inputCedRif"
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                      >
                        <option value="J">J</option>
                        <option value="V">V</option>
                        <option value="G">G</option>
                      </Select>
                    )}
                    <Input
                      ref={txtCedRif}
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      defaultValue={
                        props.inmobiliaria
                          ? props.inmobiliaria.cedrif !== null
                            ? props.inmobiliaria.cedrif
                                .trim()
                                .toUpperCase()
                                .charCodeAt(0) > 64 &&
                              props.inmobiliaria.cedrif
                                .trim()
                                .toUpperCase()
                                .charCodeAt(0) < 91
                              ? props.inmobiliaria.cedrif
                                  .trim()
                                  .substring(
                                    1,
                                    props.inmobiliaria.cedrif.trim().length
                                  )
                              : props.inmobiliaria.cedrif.trim()
                            : ""
                          : ""
                      }
                      id="inputCedula"
                      name="inputCedula"
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-3 m-0 mb-2 p-0 pl-2">
                    <Input label = 'Telefono:'
                      ref={txtTlf}
                      minLength={11}
                      maxLength={11}
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      defaultValue={
                        props.inmobiliaria
                          ? props.inmobiliaria.telefono !== null
                            ? props.inmobiliaria.telefono.trim()
                            : ""
                          : ""
                      }
                      id="inputTlf"
                      name="inputTlf"
                      onKeyUp={handleInputNumChange}
                      onBlur={handleInputNumChange}
                    />
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Input label = 'Nombre o Razon Social:'
                      ref={txtRazonS}
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      defaultValue={
                        props.inmobiliaria
                          ? props.inmobiliaria.nombrearrendatario !== null
                            ? props.inmobiliaria.nombrearrendatario.trim()
                            : ""
                          : ""
                      }
                      id="razonS"
                      name="razonS"
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-12 m-0 mb-2 p-0">
                    <Textarea label = 'Dirección del Arrendatario:'
                      style={{ height: 70 }}
                      ref={txtDirecI2}
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      defaultValue={
                        props.inmobiliaria
                          ? props.inmobiliaria.direccion !== null
                            ? props.inmobiliaria.direccion.trim()
                            : ""
                          : ""
                      }
                      id="directInm2"
                      name="directInm2"
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-12 m-0 p-0">
                    <Textarea label = 'Tipo de Actividad:'
                      style={{ height: 70 }}
                      ref={txtTipoActividad}
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      defaultValue={
                        props.inmobiliaria
                          ? props.inmobiliaria.tipoactividad !== null
                            ? props.inmobiliaria.tipoactividad.trim()
                            : ""
                          : ""
                      }
                      id="actividadP"
                      name="actividadP"
                      onChange={onChange}
                    />
                  </div>
                </fieldset>

                <fieldset className=" row col-md-12 border-azul rounded mx-auto d-flex justify-content-between mt-2">
                  <legend
                    className="float-none w-auto fw-bold"
                    style={{ fontSize: "15px" }}
                  >
                    Información Pago
                  </legend>

                  <div
                    className="row col-md-6 mx-auto"
                    style={{ visibility: "hidden" }}
                  >
                    <label
                      className="form-check-label col-md-5 my-auto"
                      htmlFor="inlineRadio2"
                    >
                      Periodo Cancelacion
                    </label>

                    <div className="form-check form-check-inline col">
                      <input
                        className="form-check-input"
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        ref={txtMensual}
                        type="radio"
                        name="radioDeclara"
                        value="1"
                        defaultChecked={
                          props.inmobiliaria &&
                          props.inmobiliaria.periododecancelacion === 1
                        }
                        id="radioSi"
                      />
                      <label className="form-check-label">Mens.</label>
                    </div>

                    <div className="form-check form-check-inline col">
                      <input
                        className="form-check-input"
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        ref={txtTrimestral}
                        type="radio"
                        name="radioDeclara"
                        value="2"
                        defaultChecked={
                          props.inmobiliaria &&
                          props.inmobiliaria.periododecancelacion === 2
                        }
                        id="radioSi"
                      />
                      <label className="form-check-label">Trimest.</label>
                    </div>

                    <div className="form-check form-check-inline col">
                      <input
                        className="form-check-input"
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        ref={txtAnual}
                        type="radio"
                        name="radioDeclara"
                        value="3"
                        defaultChecked={
                          props.inmobiliaria &&
                          props.inmobiliaria.periododecancelacion === 3
                        }
                        id="radioSi"
                      />
                      <label className="form-check-label">Anual</label>
                    </div>
                  </div>

                  <div className="col-md-9"></div>

                  {operacion !== 1 ? (
                    <div className="col-md-12 row mx-auto px-0">
                      <div className="input-group input-group-sm col-md-2 mb-1">
                        <span className="input-group-text">Año:</span>
                        <select
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          ref={txtAñoDeuda}
                          name="anioDeuda"
                          className="form-control form-control-sm m col-md-6"
                          onChange={onChange}
                        >
                          {anio &&
                            anio.map((a) => (
                              <option key={a.anio} value={a.anio}>
                                {a.anio}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="input-group input-group-sm col-md-6 mb-1">
                        <span className="input-group-text bg-transparent border-0 fw-bold">
                          Periodos de Deuda:
                        </span>
                        <span className="input-group-text">Desde</span>
                        <select
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          ref={txtDesdeDeuda}
                          name="selectDesde"
                          className="form-control form-control-sm"
                          onChange={onChange}
                        >
                          <option key="1" value="1">
                            ENERO
                          </option>
                          <option key="2" value="2">
                            FEBRERO
                          </option>
                          <option key="3" value="3">
                            MARZO
                          </option>
                          <option key="4" value="4">
                            ABRIL
                          </option>
                          <option key="5" value="5">
                            MAYO
                          </option>
                          <option key="6" value="6">
                            JUNIO
                          </option>
                          <option key="7" value="7">
                            JULIO
                          </option>
                          <option key="8" value="8">
                            AGOSTO
                          </option>
                          <option key="9" value="9">
                            SEPTIEMBRE
                          </option>
                          <option key="10" value="10">
                            OCTUBRE
                          </option>
                          <option key="11" value="11">
                            NOVIEMBRE
                          </option>
                          <option key="12" value="12">
                            DICIEMBRE
                          </option>
                        </select>
                        <span className="input-group-text">Hasta</span>
                        <select
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          ref={txtHastaDeuda}
                          name="selectHasta"
                          className="form-control form-control-sm col-md-6"
                          onChange={onChange}
                          defaultValue={"12"}
                        >
                          <option key="1" value="1">
                            ENERO
                          </option>
                          <option key="2" value="2">
                            FEBRERO
                          </option>
                          <option key="3" value="3">
                            MARZO
                          </option>
                          <option key="4" value="4">
                            ABRIL
                          </option>
                          <option key="5" value="5">
                            MAYO
                          </option>
                          <option key="6" value="6">
                            JUNIO
                          </option>
                          <option key="7" value="7">
                            JULIO
                          </option>
                          <option key="8" value="8">
                            AGOSTO
                          </option>
                          <option key="9" value="9">
                            SEPTIEMBRE
                          </option>
                          <option key="10" value="10">
                            OCTUBRE
                          </option>
                          <option key="11" value="11">
                            NOVIEMBRE
                          </option>
                          <option key="12" value="12">
                            DICIEMBRE
                          </option>
                        </select>
                      </div>

                      <div className="input-group input-group-sm col-md-4 mb-1">
                        <span className="input-group-text">Monto a Pagar:</span>
                        <input
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          type="text"
                          autoComplete="off"
                          ref={txtMontoPagar}
                          className="form-control form-control-sm text-right"
                          id="montoPagar"
                          name="montoPagar"
                          defaultValue={
                            props.inmobiliaria &&
                            props.inmobiliaria.montoarrendamiento
                              ? formatMoneda(
                                  props.inmobiliaria.montoarrendamiento
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )
                              : "0,00"
                          }
                          onKeyUp={handleInputMontoChange}
                          onBlur={handleInputMontoChange}
                        />
                        <button
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          ref={btnCargar}
                          className="btn btn-sm btn-info text-center"
                          onClick={validarParaCargarDeuda}
                        >
                          {" "}
                          Cargar
                        </button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </fieldset>
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="deuda"
              role="tabpanel"
              aria-labelledby="deuda-tab"
            >
              <div className="row col-md-12">
                <TablaDeudasEjidos
                  tabdeuda={desde1 === 0 ? props.deuda : deuda}
                  idrentas={props.inmobiliaria && props.inmobiliaria.idrentas}
                  visibleF={"hidden"}
                  credito={
                    props.credito && props.credito > 0 ? props.credito : 0.0
                  }
                />
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="historico"
              role="tabpanel"
              aria-labelledby="hist-tab"
            >
              <div className="row col-md-12 mx-auto">
                <TablaHistoricosEjidos
                  tabHis={props.historico}
                  idrentas={props.inmobiliaria && props.inmobiliaria.idrentas}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={operacion === 4 ? true : false}
          onClick={validarCampos}
        >
          Aceptar
        </SuccessButton>
        <DangerButton ref={btnCancela} onClick={salir}>
          Salir
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
